import { useState } from "react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import ConfirmDialog from "@/components/admin/ConfirmDialog";
import { api } from "@/lib/api";

// Owner/Moderator user-level warning: sends Content "warning_message" + the safety push. Reason 3–500 chars.
export default function WarnDialog({ open, onOpenChange, userId, onWarned }) {
  const [reason, setReason] = useState("");
  const n = reason.trim().length;
  const warn = async () => {
    const r = await api(`/admin/users/${userId}/warn`, { body: { reason: reason.trim() } });
    toast.success(`Warning sent. They now have ${r.warnings_count} warning${r.warnings_count === 1 ? "" : "s"}.`);
    setReason("");
    onWarned(r.warnings_count);
  };
  return (
    <ConfirmDialog open={open} onOpenChange={onOpenChange} onConfirm={warn} testId="user-warn-dialog" confirmLabel="Send warning"
      confirmDisabled={n < 3 || n > 500} title="Warn this person?"
      description="They get the “Warning message” notice from Content and a safety push. Nothing else changes on their account.">
      <div><Label htmlFor="warn-reason">Reason (internal, saved to the Admin Log)</Label>
        <Textarea id="warn-reason" rows={3} maxLength={500} value={reason} onChange={(e) => setReason(e.target.value)} className="mt-2" data-testid="user-warn-reason-input" />
        <p className="cw-muted mt-1 text-xs">{n}/500 · at least 3 characters</p></div>
    </ConfirmDialog>
  );
}
